var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_5165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00016 8.63501L8.07516 9.89001C8.45516 10.12 8.92016 9.78001 8.82016 9.35001L8.27016 6.99001L10.1052 5.40001C10.4402 5.11001 10.2602 4.56001 9.82016 4.52501L7.40516 4.32001L6.46016 2.09C6.29016 1.685 5.71016 1.685 5.54016 2.09L4.59516 4.31501L2.18016 4.52001C1.74016 4.55501 1.56016 5.10501 1.89516 5.39501L3.73016 6.98501L3.18016 9.34501C3.08016 9.77501 3.54516 10.115 3.92516 9.88501L6.00016 8.63501Z",
    fill: "#00BA88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_5165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8c189af403db88b1b28a548886e3bd41.svg";
export { ForwardRef as ReactComponent };